import { Component, effect, type ElementRef, inject, signal, viewChild } from '@angular/core';
import Color from '@arcgis/core/Color';

import { ListingsService } from '../../services/listings/listings';
import { StateService } from '../../services/state/state';
import { SiteHeader } from '../site-header/site-header';

@Component({
  imports: [SiteHeader],
  selector: 'app-layout',
  styleUrl: './layout.css',
  templateUrl: './layout.html',
})
export class Layout {
  protected readonly listingsService = inject(ListingsService);
  protected readonly stateService = inject(StateService);

  protected readonly topOfSideBarListings = viewChild<ElementRef>('topOfSideBarListings');

  protected readonly backgroundColor = signal(new Color('#d4ebb5'));

  constructor() {
    effect(() => {
      this.listingsService.filteredListings();

      const _nativeElement: HTMLElement | undefined = this.topOfSideBarListings()?.nativeElement as
        HTMLElement | undefined;
      if (_nativeElement) {
        this.stateService.isLoading.set(true);

        _nativeElement.scrollIntoView({ behavior: 'smooth' });

        setTimeout(() => {
          this.stateService.isLoading.set(false);
        }, 500);
      }
    });
  }
}
